import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _adjustPointsRequest = {};
var _adjustPointsResponse = { account: '_loyaltyAccount' };
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _bulkAccountResult = { account: '_loyaltyAccount' };
var _bulkAdjustPointsRequest = { search: '_cursorSearch' };
var _bulkAdjustPointsResponse = {};
var _bulkUpsertAccountsRequest = {};
var _bulkUpsertAccountsResponse = { result: '_bulkAccountResult' };
var _countAccountsRequest = {};
var _countAccountsResponse = {};
var _createAccountRequest = {};
var _createAccountResponse = { account: '_loyaltyAccount' };
var _cursorSearch = { aggregations: '_aggregation' };
var _earnPointsRequest = {};
var _earnPointsResponse = { account: '_loyaltyAccount' };
var _exportAccountsRequest = {};
var _exportAccountsResponse = { accounts: '_loyaltyAccount' };
var _getAccountBySecondaryIdRequest = {};
var _getAccountBySecondaryIdResponse = { account: '_loyaltyAccount' };
var _getAccountRequest = {};
var _getAccountResponse = { account: '_loyaltyAccount' };
var _getCurrentMemberAccountRequest = {};
var _getCurrentMemberAccountResponse = { account: '_loyaltyAccount' };
var _getProgramTotalsRequest = {};
var _getProgramTotalsResponse = {};
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _listAccountsRequest = {};
var _listAccountsResponse = { accounts: '_loyaltyAccount' };
var _listUserAccountsRequest = {};
var _listUserAccountsResponse = { accounts: '_loyaltyAccountForMetaSite' };
var _loyaltyAccount = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastActivityDate: 'google.protobuf.Timestamp',
    tier: '_tier',
    pointsExpiration: '_pointsExpiration',
};
var _loyaltyAccountForMetaSite = { account: '_loyaltyAccount' };
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultsScalarResult = { value: 'DOUBLE' };
var _nestedResultValue = {
    range: '_rangeResult',
    scalar: '_nestedResultsScalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _pointsExpiration = { expirationDate: 'google.protobuf.Timestamp' };
var _queryLoyaltyAccountsRequest = {};
var _queryLoyaltyAccountsResponse = { loyaltyAccounts: '_loyaltyAccount' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _redeemDeterminedAmountOfPointsRequest = {};
var _redeemDeterminedAmountOfPointsResponse = { account: '_loyaltyAccount' };
var _redeemPointsRequest = {};
var _redeemPointsResponse = { account: '_loyaltyAccount' };
var _refundTransactionRequest = {};
var _refundTransactionResponse = {};
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchAccountsRequest = { search: '_cursorSearch' };
var _searchAccountsResponse = {
    accounts: '_loyaltyAccount',
    aggregationData: '_aggregationData',
};
var _setMissingMemberIdRequest = {};
var _setMissingMemberIdResponse = { account: '_loyaltyAccount' };
var _tier = {
    updatedDate: 'google.protobuf.Timestamp',
    recalculationDate: 'google.protobuf.Timestamp',
};
function resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-accounts',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-accounts',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-accounts',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a loyalty account for one of a site's contacts.
 *
 * To create a new loyalty account, the customer must first be a site contact with a contact ID. See the Contacts API to
 * [learn more about a site's contacts](https://dev.wix.com/api/rest/contacts/contacts/contacts-v4/contact-object). The site must also
 * have an active loyalty program before loyalty accounts can be created. See the activate loyalty program endpoint
 * [to activate a site's loyalty program](https://dev.wix.com/api/rest/wix-loyalty-program/program/activate-loyalty-program).
 */
export function createAccount(payload) {
    var _a = serializer(_createAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAccountResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __createAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.CreateAccount',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAccount.fromReq = fromReq;
    __createAccount.__isAmbassador = true;
    return __createAccount;
}
/**
 * Adds points to a loyalty account.
 *
 * Only a positive amount can be added using the earn points endpoint. To adjust an account's balance
 * for a negative amount, use [Adjust Points](https://dev.wix.com/api/rest/wix-loyalty-program/accounts/adjust-points).
 */
export function earnPoints(payload) {
    var _a = serializer(_earnPointsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_earnPointsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __earnPoints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.EarnPoints',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{accountId}/earn-points',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __earnPoints.fromReq = fromReq;
    __earnPoints.__isAmbassador = true;
    return __earnPoints;
}
/**
 * Adjusts the point balance of a loyalty account.
 *
 * You can adjust the balance in two ways:
 * - `balance` allows you to set the total points balance to this new amount.
 * - `amount` allows you to adjust the points balance by this amount. This amount can be a positive number to increase the points balance or a negative number to decrease the balance.
 *
 * An account may not be adjusted to result in a negative balance. If you pass an integer in both the `balance` and the `amount` parameters then the `balance` adjustment takes effect and the
 * `amount` adjustment is ignored.
 */
export function adjustPoints(payload) {
    var _a = serializer(_adjustPointsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_adjustPointsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __adjustPoints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.AdjustPoints',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{accountId}/adjust-points',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __adjustPoints.fromReq = fromReq;
    __adjustPoints.__isAmbassador = true;
    return __adjustPoints;
}
/** Redeems points from a loyalty account, given the provided reward. */
export function redeemPoints(payload) {
    var _a = serializer(_redeemPointsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemPointsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __redeemPoints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.RedeemPoints',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{accountId}/redeem-points',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeemPoints.fromReq = fromReq;
    __redeemPoints.__isAmbassador = true;
    return __redeemPoints;
}
/** Redeems given amount of points from a loyalty account, given the provided reward. */
export function redeemDeterminedAmountOfPoints(payload) {
    var _a = serializer(_redeemDeterminedAmountOfPointsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemDeterminedAmountOfPointsResponse, { _loyaltyAccount: _loyaltyAccount, _pointsExpiration: _pointsExpiration, _tier: _tier }).fromJSON;
    function __redeemDeterminedAmountOfPoints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.RedeemDeterminedAmountOfPoints',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{accountId}/redeem-determined-points',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeemDeterminedAmountOfPoints.fromReq = fromReq;
    __redeemDeterminedAmountOfPoints.__isAmbassador = true;
    return __redeemDeterminedAmountOfPoints;
}
/** Refunds a redeem transaction by deleting the loyalty coupon and adjusting the points balance. */
export function refundTransaction(payload) {
    var _a = serializer(_refundTransactionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_refundTransactionResponse, {}).fromJSON;
    function __refundTransaction(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.RefundTransaction',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/refund-transaction',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __refundTransaction.fromReq = fromReq;
    __refundTransaction.__isAmbassador = true;
    return __refundTransaction;
}
/**
 * Retrieves an account using the loyalty account ID.
 *
 * You can also retrieve an account using a secondary ID, such as a contact ID or a member ID by using
 * the [Get Account by Secondary ID endpoint](https://dev.wix.com/api/rest/wix-loyalty-program/accounts/get-account-by-secondary-id).
 */
export function getAccount(payload) {
    var _a = serializer(_getAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccountResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __getAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.GetAccount',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccount.fromReq = fromReq;
    __getAccount.__isAmbassador = true;
    return __getAccount;
}
/**
 * Retrieves a list of loyalty accounts, given the provided paging, filtering, and sorting.
 * Query Loyalty Accounts runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * For field support for filters and sorting, see [Loyalty Accounts: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/loyalty-program/accounts/filter-and-sort).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryLoyaltyAccounts(payload) {
    var _a = serializer(_queryLoyaltyAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLoyaltyAccountsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __queryLoyaltyAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.QueryLoyaltyAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLoyaltyAccounts.fromReq = fromReq;
    __queryLoyaltyAccounts.__isAmbassador = true;
    return __queryLoyaltyAccounts;
}
/** Lists all accounts for Wix user. */
export function listUserAccounts(payload) {
    var _a = serializer(_listUserAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUserAccountsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _loyaltyAccountForMetaSite: _loyaltyAccountForMetaSite,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __listUserAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.ListUserAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/user',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUserAccounts.fromReq = fromReq;
    __listUserAccounts.__isAmbassador = true;
    return __listUserAccounts;
}
/**
 * Retrieves the total amount of points earned, redeemed, and adjusted for the entire loyalty program.
 *
 * The `balance` is the current total of points outstanding, while the `earned`, `adjusted`, and `redeemed` amounts
 * are the historically accumulated amounts. The totals include the amounts for all loyalty accounts.
 */
export function getProgramTotals(payload) {
    var _a = serializer(_getProgramTotalsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProgramTotalsResponse, {}).fromJSON;
    function __getProgramTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.GetProgramTotals',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/program-totals',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProgramTotals.fromReq = fromReq;
    __getProgramTotals.__isAmbassador = true;
    return __getProgramTotals;
}
/** Retrieves the currently logged-in member's account. */
export function getCurrentMemberAccount(payload) {
    var _a = serializer(_getCurrentMemberAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentMemberAccountResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __getCurrentMemberAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.GetCurrentMemberAccount',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/my-account',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentMemberAccount.fromReq = fromReq;
    __getCurrentMemberAccount.__isAmbassador = true;
    return __getCurrentMemberAccount;
}
/**
 * Retrieves the account belonging to the specified contact or member.
 *
 * This endpoint retrieves loyalty accounts using either a customer's contact ID or member ID. Your app can also retrieve an account
 * using the loyalty account ID by using the [Get Account endpoint](https://dev.wix.com/api/rest/wix-loyalty-program/accounts/get-account-by-secondary-id).
 */
export function getAccountBySecondaryId(payload) {
    var _a = serializer(_getAccountBySecondaryIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccountBySecondaryIdResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __getAccountBySecondaryId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.GetAccountBySecondaryId',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/fetch-by',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAccountBySecondaryId.fromReq = fromReq;
    __getAccountBySecondaryId.__isAmbassador = true;
    return __getAccountBySecondaryId;
}
/**
 * Retrieves a list of accounts, given the provided filters.
 *
 * You can retrieve selected loyalty accounts with an array of `contactIds` or retrieve a list of all of a site's loyalty accounts
 * with an empty request parameter. Use the `cursorPaging` parameters to limit how many items load at a time.
 *
 * Deprecated endpoint, please use `QueryLoyaltyAccounts` or `SearchAccounts` instead.
 * @deprecated It has been replaced with com.wixpress.loyalty.account.LoyaltyAccounts.QueryLoyaltyAccounts(), and will be removed on 2025-06-30.
 */
export function listAccounts(payload) {
    var _a = serializer(_listAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAccountsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __listAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.ListAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAccounts.fromReq = fromReq;
    __listAccounts.__isAmbassador = true;
    return __listAccounts;
}
/**
 * Retrieves a list of accounts, given the provided filters and search capabilities.
 * Search is executed on the account's name and email values.
 */
export function searchAccounts(payload) {
    var _a = serializer(_searchAccountsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchAccountsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _groupByValueResults: _groupByValueResults,
        _loyaltyAccount: _loyaltyAccount,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedResultsScalarResult: _nestedResultsScalarResult,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _pointsExpiration: _pointsExpiration,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
        _tier: _tier,
    }).fromJSON;
    function __searchAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.SearchAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchAccounts.fromReq = fromReq;
    __searchAccounts.__isAmbassador = true;
    return __searchAccounts;
}
/**
 * Endpoint that proxies request with QueryV2 payload to SearchAccounts endpoint with CursorSearch in the payload
 * If search results are expected, they should be passed in the filter as the following fields:
 * "_search_mode": "OR" or "AND"
 * "_search_expression": Any string value
 */
export function exportAccounts(payload) {
    var _a = serializer(_exportAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_exportAccountsResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __exportAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.ExportAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/export',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __exportAccounts.fromReq = fromReq;
    __exportAccounts.__isAmbassador = true;
    return __exportAccounts;
}
/**
 * Retrieves the count of found accounts, given the provided filters and search capabilities.
 *
 * This endpoint can help find the total count of accounts when used alongside [Search Accounts](https://dev.wix.com/docs/rest/crm/loyalty-program/accounts/search-accounts).
 */
export function countAccounts(payload) {
    var _a = serializer(_countAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countAccountsResponse, {}).fromJSON;
    function __countAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.CountAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countAccounts.fromReq = fromReq;
    __countAccounts.__isAmbassador = true;
    return __countAccounts;
}
/**
 * Updates points balance of multiple accounts.
 * Depending on the BulkAdjustPointsRequest.type:
 * amount - provided amount of points is appended to the accounts balance
 * balance - accounts balance is set to the provided amount
 *
 * Returns id of the asyncInfra job that takes care of the points adjustment.
 */
export function bulkAdjustPoints(payload) {
    var _a = serializer(_bulkAdjustPointsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAdjustPointsResponse, {}).fromJSON;
    function __bulkAdjustPoints(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.BulkAdjustPoints',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/bulk-adjust',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAdjustPoints.fromReq = fromReq;
    __bulkAdjustPoints.__isAmbassador = true;
    return __bulkAdjustPoints;
}
/** Creates loyalty accounts for given contactIds with given points, or updates loyalty accounts if they already exist */
export function bulkUpsertAccounts(payload) {
    var _a = serializer(_bulkUpsertAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpsertAccountsResponse, {
        _bulkAccountResult: _bulkAccountResult,
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __bulkUpsertAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.BulkUpsertAccounts',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/bulk/accounts/upsert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpsertAccounts.fromReq = fromReq;
    __bulkUpsertAccounts.__isAmbassador = true;
    return __bulkUpsertAccounts;
}
/** Updates account's member id if it is not already set but member exists */
export function setMissingMemberId(payload) {
    var _a = serializer(_setMissingMemberIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setMissingMemberIdResponse, {
        _loyaltyAccount: _loyaltyAccount,
        _pointsExpiration: _pointsExpiration,
        _tier: _tier,
    }).fromJSON;
    function __setMissingMemberId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.account',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.account.LoyaltyAccounts.SetMissingMemberId',
            url: resolveComWixpressLoyaltyAccountLoyaltyAccountsUrl({
                protoPath: '/v1/accounts/{accountId}/set-missing-memberId',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setMissingMemberId.fromReq = fromReq;
    __setMissingMemberId.__isAmbassador = true;
    return __setMissingMemberId;
}
//# sourceMappingURL=http.impl.js.map